import {
  getBuildingSumInsured,
  getContentsSumInsured,
  getWeeklyRentPaid,
  hasBuildingCoverType,
  hasContentsCoverType,
  isRentalAgreement,
} from 'scenes/landlord/selectors';
import { LandlordFunnelState } from 'scenes/landlord/types';
import { WireCoverageName, WireSumInsured } from '../types';

const toBuildingAmount = (state: LandlordFunnelState): number =>
  hasBuildingCoverType(state) ? Number(getBuildingSumInsured(state)) : 0;

const toContentsAmount = (state: LandlordFunnelState): number =>
  hasContentsCoverType(state) ? Number(getContentsSumInsured(state)) : 0;

const toWeeklyRentPaid = (state: LandlordFunnelState): number =>
  isRentalAgreement(state) ? Number(getWeeklyRentPaid(state)) : 0;

export const toWireSumsInsured = (
  state: LandlordFunnelState
): WireSumInsured[] => [
  {
    type: WireCoverageName.Building,
    amount: toBuildingAmount(state),
  },
  {
    type: WireCoverageName.Contents,
    amount: toContentsAmount(state),
  },
  {
    type: WireCoverageName.RentalReturn,
    amount: toWeeklyRentPaid(state),
  },
];
